var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYellowvector5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 240.36 186.09)",
    id: "iN-b0SgcJlhXo05hBGmsH"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-240.36, -186.09)",
    d: "M 240.35508308605338 186.08915376239514 L 240.3570830860534 186.08915376239514",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.27 -1.7 1.77 0.28 242.29 261.18)",
    id: "OgNwEj7UQDIuLbJvKY68m"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,192,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(0, 0)",
    d: "M 110.42397 -131.9554 C 112.08001999999999 -131.9554 119.36923999999999 -129.02595 121.04297 -122.49976 C 122.31945999999999 -117.52247 113.54576999999999 -83.23084 112.47613 -75.91751 C 110.03362 -59.21753999999999 122.63835 -5.780969999999996 122.63835 7.388550000000009 C 122.63835 33.76167000000001 102.22802 95.62436000000001 91.88737 112.23369000000001 C 86.77199 120.45009000000002 82.00831000000001 129.74785 72.20696000000001 131.36615 C 51.843540000000004 134.72835 23.73871000000001 122.60528000000001 23.73871000000001 122.60528000000001 C 23.73871000000001 121.79679 4.355340000000012 114.64198 -20.350069999999988 104.05455 C -33.012709999999984 98.62802 -48.19300999999999 96.19362000000001 -60.55184999999999 85.15886 C -61.85554999999999 83.99483000000001 -77.26622999999998 75.00989 -83.41942999999999 68.56849 C -88.43664999999999 63.316269999999996 -92.47237999999999 55.95469 -94.12190999999999 44.153839999999995 C -99.44961999999998 6.039099999999998 -108.82824999999998 -40.78977000000001 -111.90999 -63.76368 C -112.02748 -64.63958 -129.56768 -98.27747 -119.54772999999999 -110.10064 C -111.35316999999999 -119.76992 -75.91 -108.28424 -70.97287999999999 -107.12103 C -43.05781999999999 -100.54411 -13.268609999999988 -86.28039000000001 -6.3011399999999895 -86.28039000000001 C 22.42011000000001 -86.28039000000001 81.70273000000002 -131.95539000000002 110.42398000000001 -131.95539000000002 z",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowvector5);
export default __webpack_public_path__ + "static/media/yellowvector5.0c533aaef777d6fd67252c4c1ba2ffc3.svg";
export { ForwardRef as ReactComponent };